import React from 'react';
import { TDR } from 'tdr-common';
import { TableTags } from '../table-tags/TableTags';

type TableDrawerTagsProps = {
	table: TDR.Table;
};

export const TableDrawerTags = ({ table }: TableDrawerTagsProps) => {
	const guestCount =
		table.minGuests === table.maxGuests
			? String(table.minGuests)
			: String(table.minGuests) + '-' + String(table.maxGuests);

	return <TableTags attributes={table.attributes ?? {}} guestCount={guestCount} />;
};
